/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Node } from '@msdyn365-commerce-modules/utilities';
import classnames from 'classnames';
import * as React from 'react';
import { IMfrmFooterEmailSubscriptionViewProps } from './mfrm-footer-email-subscription';

export default (props: IMfrmFooterEmailSubscriptionViewProps) => {
    const { title, form, alertMessage, className } = props;
    return (
        <Node {...{ className: classnames('ms-footer__email-subscription vert-space-md', className) }}>
            {title}
            {form}
            {alertMessage}
        </Node>
    );
};
